import React, { useEffect, useState } from "react";
import CreateRecallTab from "../../components/recall/CreateRecallTab";
import { errorToast } from "../../hooks/useToast";
import { API } from "../../api";
import { useSelector } from "react-redux";
import MetaData from "../../components/seo/MetaData";

const CreateRecallForm = () => {
  const [categories, setCategories] = useState(false);

  const recallFreeTrial = useSelector(
    (state) => state.user.user.recallFreeTrial
  );
 
  const [attempts, setAttempts] = useState(false);

  const getData = async () => {
    try {
      const response = await API.getAllCategoriesRecall();
      const isLive = response?.data?.data;

      setCategories(isLive?.filter((item) => item?.isLive));

      const response1 = await API.attemptsLeftRecall();
      setAttempts(response1?.data?.data);
    } catch (error) {
      console.log(error);
      errorToast(error, "Can not fetch subjects");
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div className="max-w-[530px] w-full mx-auto px-3  ">
      <MetaData
        title={"AMC MCQ Recall Practice Questions - Qbank Model"}
        description={
          "Practice with top AMC MCQ recall questions. Enhance your medical knowledge and boost your recall performance with Qbank Model's comprehensive practice tests."
        }
        keywords={
          "AMC MCQ recall practice, medical questions, recall preparation, Qbank Model practice tests"
        }
      />
      <CreateRecallTab
        categories={categories}
        freeTrial={recallFreeTrial}
        attempts={attempts}
      />
    </div>
  );
};

export default CreateRecallForm;
